/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use it for names or tasks?`)
};

const es_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo usarla para nombres o tareas?`)
};

const de_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich es für Namen oder Aufgaben verwenden?`)
};

const nl_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik het gebruiken voor namen of taken?`)
};

const fr_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je l'utiliser pour des noms ou des tâches ?`)
};

const it_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usarla per nomi o compiti?`)
};

const pt_br2_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usar para nomes ou tarefas?`)
};

const pt_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso usá-la para nomes ou tarefas?`)
};

const ja_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前やタスクにも使えますか?`)
};

const zh_dw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我能用它来抽姓名或任务吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_q3", locale)
	if (locale === "en") return en_dw_faq_q3(inputs)
	if (locale === "es") return es_dw_faq_q3(inputs)
	if (locale === "de") return de_dw_faq_q3(inputs)
	if (locale === "nl") return nl_dw_faq_q3(inputs)
	if (locale === "fr") return fr_dw_faq_q3(inputs)
	if (locale === "it") return it_dw_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_q3(inputs)
	if (locale === "pt") return pt_dw_faq_q3(inputs)
	if (locale === "ja") return ja_dw_faq_q3(inputs)
	return zh_dw_faq_q3(inputs)
};